import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e786b8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formState,
    rules: _ctx.rules,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "组织名称",
        name: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
            placeholder: "请输入"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "pid",
        label: "上级组织",
        name: "pid"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_cascader, {
            value: _ctx.formState.pid,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.pid) = $event)),
            changeOnSelect: true,
            placeholder: "请选择",
            "field-names": { label: 'name', value: 'id', children: 'children' },
            options: _ctx.list
          }, null, 8, ["value", "options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 6 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}